export default __webpack_public_path__ + "static/media/file-icon-ppt.61583b10.svg";